import { connect } from 'react-redux';
import { find } from 'lodash';
import { pauseApiKey, activateApiKey, rotateApiKey, deleteApiKey } from '../../../actions';
import {
  ACTIVATE_API_KEY,
  PAUSE_API_KEY,
  ROTATE_API_KEY,
  DELETE_API_KEY,
} from '../../../constants/processTypes';
import APIKeyDetailActions from './APIKeyDetailActions';
import { useResourceDetailHandler } from 'new/components/ResourceDetailHandler/context';

const mapStateToProps = (state, ownProps) => {
  const {
    processes: { all: processes },
  } = state;
  const {
    data: { id },
  } = ownProps;
  const isPausing = !!find(processes, { type: PAUSE_API_KEY, id });
  const isActivating = !!find(processes, { type: ACTIVATE_API_KEY, id });
  const isRotating = !!find(processes, { type: ROTATE_API_KEY, id });
  const isDeleting = !!find(processes, { type: DELETE_API_KEY, id });

  return {
    isPausing,
    isActivating,
    isRotating,
    isDeleting,
  };
};

function APIKeyDetailActionsWithContext(props) {
  const { openDetailDrawerInPortal } = useResourceDetailHandler();
  return <APIKeyDetailActions {...props} openDetailDrawerInPortal={openDetailDrawerInPortal} />;
}

export default connect(mapStateToProps, {
  pauseApiKey,
  activateApiKey,
  rotateApiKey,
  deleteApiKey,
})(APIKeyDetailActionsWithContext);
